module.exports = __webpack_public_path__ + "img/dalong2.5eeb9b62.svg";